export const visit = (vm, at) => {
at({ "en": { "uiAddonDraggable": { "add": "Add" } } });
};